module.exports = __webpack_public_path__ + "static/media/photo201.28a85a6c.jpg";